import Vue from 'vue';

export default {
    generarPoliza(parametros) {
        return Vue.axios.post("calculo-nomina/generar-poliza", parametros).then((response) => Promise.resolve(response.data)).catch((error) => Promise.reject(error));
    },
    findNominas(parametros) {
        return Vue.axios.get("calculo-nomina/listado", { params: parametros }).then((response) => Promise.resolve(response.data)).catch((error) => Promise.reject(error));
    },
}